module.exports = __webpack_public_path__ + "img/etax-lineHeader.43daadb.png";